

export default {
  name: 'ListingProductsListItemReviews',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  methods: {
    goTo(link) {
      if (!link) {
        return;
      }
      this.$router.push(link);
    },
  },
};
